import { css } from '@emotion/core';
import { rgba, tokens, globalTokens } from '@domain-group/fe-brary';
var _tokens$colors = tokens.colors,
  interactive = _tokens$colors.interactive,
  neutral = _tokens$colors.neutral;
var defaultFocus = /*#__PURE__*/css("outline:1px solid ", neutral.heavy.default, ";");
var solidDisabled = /*#__PURE__*/css("border:1px solid ", neutral.medium.default, ";background-color:", neutral.heavy.disabled, ";color:", neutral.surface.default, ";");
var generateButton = _ref => {
  var normal = _ref.normal,
    hover = _ref.hover,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? normal : _ref$active,
    _ref$focus = _ref.focus,
    focus = _ref$focus === void 0 ? defaultFocus : _ref$focus,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? solidDisabled : _ref$disabled;
  return /*#__PURE__*/css(normal, ";:focus,:hover{", normal, ";}:active{", active, ";}:focus{", focus, "}:disabled,:disabled:active,:disabled:hover,:disabled:active:hover{", disabled, "}:active:hover{", hover, ";}@media (hover:hover) and (pointer:fine){:hover{", hover, ";}}");
};
export var primary = generateButton({
  normal: /*#__PURE__*/css("border:1px solid ", interactive.medium.default, ";background-color:", interactive.base.default, ";color:", neutral.surface.default, ";"),
  hover: /*#__PURE__*/css("border:1px solid ", interactive.medium.hover, ";background-color:", interactive.base.hover, ";color:", neutral.surface.hover, ";")
});
export var secondary = generateButton({
  normal: /*#__PURE__*/css("border:1px solid ", neutral.heavy.default, ";background-color:", neutral.heavy.default, ";color:", neutral.surface.default, ";:disabled{border:1px solid ", neutral.medium.default, ";}"),
  hover: /*#__PURE__*/css("border:1px solid ", neutral.heavy.hover, ";background-color:", neutral.heavy.hover, ";color:", neutral.surface.hover, ";")
});
var outlineHover = /*#__PURE__*/css("background-color:", neutral.background.hover, ";");
var outlineDisabled = /*#__PURE__*/css("border:1px solid ", neutral.heavy.disabled, ";background-color:", neutral.surface.default, ";color:", neutral.heavy.disabled, ";");
export var outline = generateButton({
  normal: /*#__PURE__*/css("border:1px solid ", neutral.heavy.default, ";background-color:", neutral.surface.default, ";color:", neutral.heavy.default, ";"),
  hover: outlineHover,
  disabled: outlineDisabled
});
export var outlineTrim = generateButton({
  normal: /*#__PURE__*/css("border:1px solid ", neutral.trim.default, ";background-color:", neutral.surface.default, ";color:", neutral.heavy.default, ";"),
  hover: outlineHover,
  disabled: outlineDisabled
});
export var outlineMedium = generateButton({
  normal: /*#__PURE__*/css("border:1px solid ", neutral.medium.default, ";background-color:", neutral.surface.default, ";color:", neutral.heavy.default, ";"),
  hover: outlineHover,
  disabled: outlineDisabled
});
export var outlineSelected = generateButton({
  normal: /*#__PURE__*/css("border:2px solid ", neutral.heavy.default, ";background-color:", neutral.subdued.default, ";color:", neutral.heavy.default, ";"),
  hover: /*#__PURE__*/css("background-color:", neutral.subdued.hover, ";"),
  disabled: /*#__PURE__*/css("border:2px solid ", neutral.heavy.disabled, ";background-color:", neutral.subdued.default, ";color:", neutral.heavy.disabled, ";")
});
export var ghost = generateButton({
  normal: /*#__PURE__*/css("border:1px solid transparent;background-color:transparent;color:", interactive.base.default, ";"),
  hover: /*#__PURE__*/css("border:1px solid ", neutral.background.hover, ";background-color:", neutral.background.hover, ";"),
  disabled: /*#__PURE__*/css("color:", interactive.heavy.disabled, ";border:1px solid transparent;background-color:transparent;")
});
export var ghostNeutral = generateButton({
  normal: /*#__PURE__*/css("border:1px solid transparent;background-color:transparent;color:", neutral.heavy.default, ";"),
  hover: /*#__PURE__*/css("border:1px solid ", neutral.background.hover, ";background-color:", neutral.background.hover, ";"),
  disabled: /*#__PURE__*/css("color:", neutral.heavy.disabled, ";border:1px solid transparent;background-color:transparent;")
});
export var transparent = generateButton({
  normal: /*#__PURE__*/css("border:1px solid ", rgba(globalTokens.colors.black, 0.7), ";background-color:", rgba(globalTokens.colors.black, 0.7), ";color:", neutral.surface.default, ";"),
  hover: /*#__PURE__*/css("border:1px solid ", neutral.heavy.default, ";background-color:", neutral.heavy.default, ";color:", neutral.surface.hover, ";")
});
export var standard = primary;
export var accent = primary;
export var secondaryNeutral = outline;
export var neutralFilled = secondary;